import { render, staticRenderFns } from "./CaretIcon.vue?vue&type=template&id=5033d154&scoped=true&"
import script from "./CaretIcon.vue?vue&type=script&lang=js&"
export * from "./CaretIcon.vue?vue&type=script&lang=js&"
import style0 from "./CaretIcon.vue?vue&type=style&index=0&id=5033d154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5033d154",
  null
  
)

export default component.exports